import { IIpoListAPIPayload, IIpoListAPIResponse } from "../types/ipo-list-types.types";
import { API_PATHS } from "../constants/api-paths";
import { request } from "../core/api.client";

export const getIpoList = async (payload: IIpoListAPIPayload) => {
  const response: IIpoListAPIResponse = await request({
    method: "POST",
    url: `${API_PATHS.ipoList}`,
    data: payload,
  });
  return response;
};
